import {Component} from '@angular/core';
import {importStepperConfig} from './faults-import-stepper.config';
import {importStepperOptions} from './faults-import-stepper.options';
import {StepperReadyEvent} from '@mydocma/import-export';
import {FaultsImportStepperService} from './services/fault-import-stepper.service';

@Component({
  selector: 'mydocma-mm-faults-import-stepper',
  templateUrl: './faults-import-stepper.component.html',
  styleUrls: ['./faults-import-stepper.component.scss'],
  providers: []
})
export class FaultsImportStepperComponent {

  protected readonly stepperOptions = importStepperOptions;
  protected readonly stepperConfig = importStepperConfig;

  constructor(private readonly importStepperService: FaultsImportStepperService) {
  }

  onReadyEvent(event: StepperReadyEvent) {
    this.importStepperService.stepperService = event.stepperService;
  }
}
